import { Link } from "react-router-dom";
import { GENRES } from "@/lib/categories";
import { getAllMovies } from "@/lib/movies";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryShortcuts() {
  const allMovies = getAllMovies();

  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="Browse by genre"
        title="按类型找片"
        description="12 个类型分区，从高能动作到温柔爱情，从深空科幻到东方奇幻，今晚想看什么，从这里开始。"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6">
        {GENRES.map((genre) => {
          const count = allMovies.filter((movie) => movie.genres.includes(genre.name)).length;
          return (
            <Link
              key={genre.name}
              to={`/category/${encodeURIComponent(genre.name)}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-100 p-3.5 transition-colors hover:border-primary-500/50 hover:bg-background-200/60 md:p-4"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-200/80 text-primary-300 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${genre.icon} text-lg`} />
              </span>
              <span className="min-w-0">
                <span className="block whitespace-nowrap font-heading text-sm font-medium text-foreground-100">
                  {genre.name}片
                </span>
                <span className="mt-0.5 block text-xs text-foreground-500">{count} 部影片</span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}